import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';

@Component({
    selector: 'login-header',
    templateUrl: './login-header.component.html',
    styleUrls: ['./login-header.component.css'],
    standalone: false
})
export class LoginHeaderComponent implements OnInit {
  classToggled = false;
  isAboutUspage: boolean = false;
  isHowitworkspage: boolean = false;
  isFamiliespage: boolean = false;
  families: boolean=false;
  public toggleField() {
    this.classToggled = !this.classToggled;
  }

  @ViewChild('pricing') pricing;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loader.HideLoading();
    const currentRoute = this.route.snapshot.url[0]?.path;
    if (currentRoute === 'aboutus') {
      this.isAboutUspage = true;
    } else if (currentRoute === 'how-it-works') {
      this.isHowitworkspage = true;
    } else if(currentRoute === 'families'){
      this.isFamiliespage=true;
    }
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  onClose() {
    this.modalService.dismissAll();
  }

  // Check the scroll position and add/remove the class accordingly added by vinod
  isScrolled: boolean = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    setTimeout(() => {
      this.isScrolled = window.scrollY > 0;
    });
  }
}
